import { useState, FunctionComponent } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import Contact1stdibsModal from '../../contact1stdibs/Contact1stdibsModal';
import { Link } from 'dibs-elements/exports/Link';

import styles from './Contact1stdibsLink.scss';

type Contact1stdibsLinkProps = {
    isNavigationHovered: boolean;
};

const Contact1stdibsLink: FunctionComponent<Contact1stdibsLinkProps> = ({
    isNavigationHovered,
}) => {
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const contactClassName = classNames(styles.contact1stdibs, {
        [styles.hoveredNavigation]: isNavigationHovered,
    });
    return (
        <>
            <div className={styles.wrapper}>
                <Link
                    className={styles.container}
                    onClick={() => {
                        setIsContactModalOpen(true);
                    }}
                >
                    {/* element below is used as an anchor for `ContactTradeRepTooltip.tsx`, hence the ID */}
                    <div
                        className={contactClassName}
                        data-tn="contact-1stdibs-link"
                        id="trade-spec"
                    >
                        <FormattedMessage
                            id="dbl.contact1stdibsLink.contact1stdibs"
                            defaultMessage="Contact 1stDibs"
                        />
                    </div>
                </Link>
            </div>

            <Contact1stdibsModal
                isOpen={isContactModalOpen}
                placement="globalNav"
                onClose={() => setIsContactModalOpen(false)}
            />
        </>
    );
};

export default Contact1stdibsLink;
